import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/img/logo/w-logo.svg';
import Linkedin from '../../assets/img/logo/linkedin-logo.svg';
import Style from './style.module.scss';

const Footer = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const ROUTES = [
    {
      key: 'cookie',
      tr: '/cerez-politikasi',
      en: '/cookie-policy',
      route: t('routes.cookiePolicy'),
      title: t('cookiePolicy'),
    },
    {
      key: 'kvkk',
      tr: '/kisisel-verileri-koruma',
      en: '/personel-data-protection-gdpr',
      route: t('routes.gdpr'),
      title: t('privacyPolicy'),
    },
    {
      key: 'contact',
      tr: '/iletisim',
      en: '/contact',
      route: t('routes.contact'),
      title: t('contact'),
    },
  ];

  const isActiveRoute = (item, pathname) => {
    return item.tr === pathname || item.en === pathname;
  };

  return (
    <footer className={Style.footer}>
      <div className={Style.container}>
        <div className={Style.logoWrapper}>
          <img src={Logo} alt="Logo" />
          <a
            href="https://www.linkedin.com/company/ngaming/jobs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Linkedin} alt="nGaming-Linkedin-logo" />
          </a>
        </div>
        <div className={Style.copyrightWrapper}>
          <p className={Style.copyright}>Copyright © 2026 | NGAMING</p>
          <div className={Style.policies}>
            {ROUTES.map((item) => {
              const isActive = isActiveRoute(item, pathname);
              return (
                <Link
                  key={item.key}
                  to={item.route}
                  className={clsx({ [Style.activeLink]: isActive })}
                >
                  {item.title}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
